import { useState } from 'react'
import { useNavigate, Navigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import { SHORT_URL, postLogoUrl } from '../lib/genemoApps'
import { LegalFooter } from '../components/LegalFooter'

/** ログイン（DESIGN-SYSTEM.md の Auth screens・components.css の gm-auth*） */
export function Login() {
  const { user, login } = useAuth()
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [remember, setRemember] = useState(true)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  if (user) return <Navigate to="/" replace />

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(''); setBusy(true)
    try {
      await login(email, password, remember)
      nav('/')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'ログインに失敗しました')
    } finally { setBusy(false) }
  }

  return (
    <div className="gm-auth">
      <div className="gm-auth-inner">
        <div className="gm-auth-brand">
          <img src={postLogoUrl} alt="Genemo Post" />
          <p>SNS投稿をAIで作って届ける</p>
        </div>

        <form onSubmit={submit} className="gm-auth-card">
          <h1>ログイン</h1>
          <div className="gm-field">
            <label htmlFor="login-email">メールアドレス</label>
            <input
              id="login-email" autoComplete="email" className="gm-input"
              type="email" value={email} onChange={e => setEmail(e.target.value)} required
              aria-describedby={error ? 'login-error' : undefined}
              placeholder="you@example.com"
            />
          </div>
          <div className="gm-field">
            <label htmlFor="login-password">パスワード</label>
            <input
              id="login-password" autoComplete="current-password" className="gm-input"
              type="password" value={password} onChange={e => setPassword(e.target.value)} required
              aria-describedby={error ? 'login-error' : undefined}
            />
            {error && (
              <p id="login-error" role="alert" className="gm-error">
                {error}
                <br />
                入力内容を確認して、もう一度お試しください。
              </p>
            )}
          </div>
          <label className="flex items-center gap-2 text-[13px] text-ink-muted">
            <input type="checkbox" className="accent-primary" checked={remember} onChange={e => setRemember(e.target.checked)} /> ログイン状態を保持
          </label>
          <button type="submit" disabled={busy} className="gm-btn gm-btn-primary gm-btn-block">
            {busy && <Loader2 size={16} className="motion-safe:animate-spin" aria-hidden />}
            {busy ? 'ログイン中…' : 'ログイン'}
          </button>
        </form>

        <p className="gm-auth-foot">
          アカウントは Genemo 共通です。新規登録・パスワード再設定は Genemo Short で行えます。
          <br />
          <a href={SHORT_URL} target="_blank" rel="noreferrer">Genemo Short を開く</a>
        </p>
        <LegalFooter />
      </div>
    </div>
  )
}
